import breadcrumb from '@/components/breadcrumb/breadcrumb'
const index = {
    install(Vue){
        Vue.component('breadcrumb',breadcrumb)
    }
};

export default index;
